$rise_toggle $mol_check
	minimal_height 24
	minimal_width 24
	sub /
